import MuiPopover, { type PopoverProps } from "@mui/material/Popover";

export type { PopoverProps };

export function Popover({ slotProps, ...props }: PopoverProps) {
  return (
    <MuiPopover
      {...props}
      slotProps={{
        ...slotProps,
        backdrop: {
          ...((typeof slotProps?.backdrop === 'object' ? slotProps.backdrop : {}) as Record<string, unknown>),
          sx: { backgroundColor: "transparent" },
        },
      }}
    />
  );
}
